const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSCircleTriangleDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-circle-triangle-down",
    x: 0.023,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-circle-triangle-down1",
    serifid: "iconS-circle-triangle-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.023,4c-4.419,0 -8,3.581 -8,8c-0,4.419 3.581,8 8,8c4.419,0 8,-3.581 8,-8c-0,-4.419 -3.581,-8 -8,-8Zm4.206,7.706l-3.5,3.5c-0.194,0.197 -0.45,0.294 -0.706,0.294c-0.256,0 -0.512,-0.098 -0.707,-0.293l-3.5,-3.5c-0.391,-0.391 -0.401,-1.034 -0,-1.414c0.308,-0.291 0.599,-0.293 1.207,-0.293l6.001,0c0.548,0.001 0.874,0.004 1.206,0.294c0.416,0.364 0.39,1.022 -0.001,1.412Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSCircleTriangleDown);
export default __webpack_public_path__ + "static/media/iconS-circle-triangle-down.9357120e712990ef5675d8b588644d71.svg";
export { ForwardRef as ReactComponent };